import React from 'react';
import { renderMessage } from './render';
const builtInTransforms = [
    {
        name: 'bold',
        pattern: /<b>(?<value>.*?)<\/b>/gim,
        Wrapper: ({ children }) => React.createElement("b", null, children),
    },
    {
        name: 'italic',
        pattern: /<i>(?<value>.*?)<\/i>/gim,
        Wrapper: ({ children }) => React.createElement("i", null, children),
    },
];
export const transformMessage = (message, args = {}) => {
    const transforms = Object.entries(args)
        .filter((entry) => typeof entry[1] === 'function')
        .map(([name, Wrapper]) => ({
        name,
        Wrapper,
        pattern: new RegExp(`{${name}}(?<value>.*?){/${name}}`, 'gim'),
    }));
    let transformedMessage = message;
    const transformedArgs = { ...args };
    [...builtInTransforms, ...transforms].forEach(({ Wrapper, pattern, name }) => {
        var _a;
        let result = pattern.exec(transformedMessage);
        while (result !== null) {
            const [match] = result;
            const key = `${name}:${result.index}`;
            const value = (_a = result.groups) === null || _a === void 0 ? void 0 : _a.value;
            if (!value)
                throw new Error(`The transform "${name}" does not define a capture group named "value".`);
            const transformed = transformMessage(value, transformedArgs);
            const child = renderMessage(transformed);
            transformedArgs[key] = React.createElement(Wrapper, { ...result.groups }, child);
            transformedMessage = transformedMessage.replace(match, `{${key}}`);
            result = pattern.exec(transformedMessage);
        }
    });
    return {
        message: transformedMessage,
        args: transformedArgs,
    };
};
//# sourceMappingURL=transform.js.map